import { render, staticRenderFns } from "./storicoVendite.vue?vue&type=template&id=cc0fcb2e"
import script from "./storicoVendite.vue?vue&type=script&lang=js"
export * from "./storicoVendite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports